// This file was auto-generated by Fern from our API Definition.
export const ExistenceOperator = {
    Exists: "exists",
    NotExists: "not_exists",
};
